module.exports = __webpack_public_path__ + "img/Teaching Case Icon.c82347b0.png";